window.abTesting.rerenderMainProductSection = function () {
	fetch(window.location.pathname + '?view=abtesting-variation')
		.then((res) => res.text())
		.then((html) => {
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');
			const variantPicker = doc.querySelector('[variant-picker-wrapper]');
			const productForm = document.querySelector('[variant-picker-wrapper]');
			productForm.innerHTML = variantPicker.innerHTML;
			const quickAdd = doc.querySelector('product-quick-add');
			const quickAddContainer = document.querySelector('product-quick-add');
			quickAddContainer.parentElement.replaceChild(quickAdd, quickAddContainer);
			productForm.classList.remove('product-section-variant-picker--B');
			productForm.classList.add('product-section-variant-picker--A', 'section--narrow');
		});
};
class ThumbnailsSlider extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		this.leftButton = this.querySelector('.thumbnails-button--left');
		this.rightButton = this.querySelector('.thumbnails-button--right');
		this.thumbnailWrapper = this.querySelector('.thumbnails-slider__content-wrapper');
		this.thumbnailSlider = this.querySelector('.product-gallery__thumbnail-list');
		this.initButtons();
		this.initCssVariables();
		this.initThumbnailMutationObserver();
		window.addEventListener('resize', this.initCssVariables.bind(this));
	}

	initCssVariables() {
		const thumbnailWrapperWidth = this.thumbnailWrapper.offsetWidth;
		const itemWidth = this.querySelector('.product-gallery__thumbnail').offsetWidth;
		const gapWidthDesktop = (thumbnailWrapperWidth - 6 * itemWidth) / 5;
		const gapWidthMobile = (thumbnailWrapperWidth - 5 * itemWidth) / 4;
		if (gapWidthDesktop > 0) {
			this.thumbnailWrapper.style.setProperty('--thumbnail-gap-desktop', `${gapWidthDesktop}px`);
		}
		if (gapWidthMobile > 0) {
			this.thumbnailWrapper.style.setProperty('--thumbnail-gap-mobile', `${gapWidthMobile}px`);
		}
	}

	initButtons() {
		this.leftButton.addEventListener('click', this.scrollToLeft.bind(this));
		this.rightButton.addEventListener('click', this.scrollToRight.bind(this));
		if (this.thumbnailSlider.offsetWidth <= this.thumbnailWrapper.offsetWidth) {
			this.hideButton(this.leftButton);
			this.hideButton(this.rightButton);
		}
	}

	initThumbnailMutationObserver() {
		const mutationCallback = (mutationsList, observer) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'attributes' && mutation.attributeName === 'aria-current') {
					const targetElement = mutation.target;
					if (targetElement.getAttribute('aria-current') === 'true') {
						const thumbnailWrapperRect = this.thumbnailWrapper.getBoundingClientRect();
						const targetElementRect = targetElement.getBoundingClientRect();

						if (targetElementRect.right > thumbnailWrapperRect.right) {
							this.scrollToRight();
						} else if (targetElementRect.left < thumbnailWrapperRect.left) {
							this.scrollToLeft();
						}
					}
				}
			}
		};

		const observer = new MutationObserver(mutationCallback);

		const observerConfig = {
			attributes: true,
			attributeFilter: ['aria-current'],
		};

		const observeItems = this.querySelectorAll('.product-gallery__thumbnail');

		for (const item of observeItems) {
			observer.observe(item, observerConfig);
		}
	}

	hideButton(button) {
		button.setAttribute('disabled', '');
	}

	scrollToLeft() {
		if (!this.leftButton.hasAttribute('disabled')) {
			this.thumbnailWrapper.scrollLeft = 0;
			this.leftButton.setAttribute('disabled', '');
			this.rightButton.removeAttribute('disabled');
		}
	}

	scrollToRight() {
		if (!this.rightButton.hasAttribute('disabled')) {
			this.thumbnailWrapper.scrollLeft = this.thumbnailSlider.offsetWidth - this.thumbnailWrapper.offsetWidth + 1;
			this.leftButton.removeAttribute('disabled');
			this.rightButton.setAttribute('disabled', '');
		}
	}
}
if (!customElements.get('thumbnails-slider')) {
	customElements.define('thumbnails-slider', ThumbnailsSlider);
}

class AutoCloseTabs extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.tabs = this.querySelectorAll('details');
		this.initMutationObserver();
		this.addTabsAttributes('autoclose');
	}

	addTabsAttributes(attribute) {
		this.tabs.forEach((tab) => {
			tab.setAttribute(attribute, '');
		});
	}

	initMutationObserver() {
		const mutationCallback = (mutationsList, observer) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
					const targetElement = mutation.target;
					if (targetElement.open) {
						this.updateTabs(targetElement);
						setTimeout(() => {
							this.scrollIntoView(targetElement);
						}, 200);
					}
				}
			}
		};
		const observer = new MutationObserver(mutationCallback);
		const observerConfig = {
			attributes: true,
			attributeFilter: ['open'],
		};
		for (const item of this.tabs) {
			observer.observe(item, observerConfig);
		}
	}

	updateTabs(targetElement) {
		this.tabs.forEach((tab) => {
			if (tab !== targetElement) {
				tab._open = false;
				tab._transition(false);
				tab.removeAttribute('open');
			}
		});
	}

	scrollIntoView(element) {
		if (element) {
			element.scrollIntoView({ behavior: 'smooth' });
		}
	}
}

if (!customElements.get('auto-close-tabs')) {
	customElements.define('auto-close-tabs', AutoCloseTabs);
}

// Function to append all parameters to clickout links
(function () {
	'use strict';

	// Get ALL parameters from current URL
	const urlSearchParams = new URLSearchParams(window.location.search);

	// Convert all parameters to string
	let paramsToAppend = urlSearchParams.toString();

	// If no parameters exist, use default
	if (!paramsToAppend) {
		paramsToAppend = 'onfySource=PharmaSGP';
		console.log('No parameters found. Using default:', paramsToAppend);
	} else {
		console.log('Passing all parameters from URL:', paramsToAppend);
	}

	// Helper function to append parameters to a URL
	function appendParamsToUrl(url) {
		if (!url || !paramsToAppend) return url;

		// Parse URL and its existing parameters
		const [baseUrl, queryString] = url.split('?');
		const existingParams = new URLSearchParams(queryString || '');
		const newParams = new URLSearchParams(paramsToAppend);

		// Add only parameters that don't already exist
		let hasNewParams = false;
		newParams.forEach((value, key) => {
			if (!existingParams.has(key)) {
				existingParams.append(key, value);
				hasNewParams = true;
			}
		});

		// Return original URL if no new parameters added
		if (!hasNewParams) return url;

		// Return URL with parameters
		return existingParams.toString() ? `${baseUrl}?${existingParams.toString()}` : baseUrl;
	}

	// Intercept window.open to add parameters to clickout links
	const originalWindowOpen = window.open;
	window.open = function (url, target, ...args) {
		// Only modify URLs going to onfy.de
		if (url && url.includes('onfy.de')) {
			const updatedUrl = appendParamsToUrl(url);
			if (updatedUrl !== url) {
				console.log('Added parameters to:', updatedUrl);
			}
			return originalWindowOpen.call(this, updatedUrl, target, ...args);
		}
		return originalWindowOpen.call(this, url, target, ...args);
	};
})();

// Run the script only if the page is a Shopify blog post
document.addEventListener('DOMContentLoaded', () => {
	if (window.location.pathname.includes('/blogs/')) {
		appendParamsToLinks();
	}
});

class RichAccordion extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.button = this.querySelector('.accordion__toggle--button');
		this.text = this.querySelector('.accordion__content');
		this.open = this.hasAttribute('open');
		this.setContentHeight();
		this.setInitialHeight();
		this.initButton(this.button);
		this.setMinHeight();
		window.addEventListener('resize', this.onWidthChange.bind(this));
	}

	setContentHeight() {
		this.maxHeight = this.text.scrollHeight;
	}

	setMinHeight() {
		if (this.hasAttribute('data-min-height-mobile')) {
			const minHeightMobile = this.convertRemToPixels(this.getAttribute('data-min-height-mobile'));
			this.text.style.setProperty('--accordion-toggle-min-height-mobile', `${minHeightMobile}px`);
		}
		if (this.hasAttribute('data-min-height-desktop')) {
			const minHeightDesktop = this.convertRemToPixels(this.getAttribute('data-min-height-desktop'));
			this.text.style.setProperty('--accordion-toggle-min-height-desktop', `${minHeightDesktop}px`);
		}
	}

	convertRemToPixels(rem) {
		return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
	}

	initButton(button) {
		button.addEventListener('click', this.toggleAccordion.bind(this));
	}

	setInitialHeight() {
		if (this.open) {
			this.text.style.setProperty('--accordion-toggle-height', `${this.maxHeight}px`);
		} else {
			this.text.style.setProperty('--accordion-toggle-height', '0px');
		}
	}

	onWidthChange() {
		this.setContentHeight();
		this.setInitialHeight();
	}

	toggleAccordion() {
		if (this.open) {
			this.text.style.setProperty('--accordion-toggle-height', '0px');
			this.open = false;
			this.setAttribute('aria-expanded', 'false');
		} else {
			this.text.style.setProperty('--accordion-toggle-height', `${this.maxHeight}px`);
			this.open = true;
			this.setAttribute('aria-expanded', 'true');
		}
	}
}

if (!customElements.get('rich-accordion')) {
	customElements.define('rich-accordion', RichAccordion);
}

class ScrollingCollapsible extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		if (!this.getAttribute('enabled') === 'true') {
			return;
		}
		this.button = this.querySelector('.scrolling-collapsible__button');
		this.text = this.querySelector('.prose');
		this.open = this.getAttribute('aria-expanded') === 'true';
		this.setContentHeight();
		this.setInitialHeight();
		this.initButton(this.button);
		this.setMinHeight();
		window.addEventListener('resize', this.onWidthChange.bind(this));
	}

	setContentHeight() {
		this.maxHeight = this.text.scrollHeight;
	}

	setMinHeight() {
		if (this.hasAttribute('data-min-height-mobile')) {
			const minHeightMobile = this.convertRemToPixels(this.getAttribute('data-min-height-mobile'));
			this.text.style.setProperty('--accordion-toggle-min-height-mobile', `${minHeightMobile}px`);
		}
		if (this.hasAttribute('data-min-height-desktop')) {
			const minHeightDesktop = this.convertRemToPixels(this.getAttribute('data-min-height-desktop'));
			this.text.style.setProperty('--accordion-toggle-min-height-desktop', `${minHeightDesktop}px`);
		}
	}

	convertRemToPixels(rem) {
		return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
	}

	initButton(button) {
		button.addEventListener('click', this.toggleAccordion.bind(this));
	}

	setInitialHeight() {
		if (this.open) {
			this.text.style.setProperty('--accordion-toggle-height', `${this.maxHeight}px`);
		} else {
			this.text.style.setProperty('--accordion-toggle-height', '0px');
		}
	}

	onWidthChange() {
		this.setContentHeight();
		this.setInitialHeight();
	}

	toggleAccordion() {
		if (this.open) {
			this.text.style.setProperty('--accordion-toggle-height', '0px');
			this.open = false;
			this.setAttribute('aria-expanded', 'false');
		} else {
			this.text.style.setProperty('--accordion-toggle-height', `${this.maxHeight}px`);
			this.open = true;
			this.setAttribute('aria-expanded', 'true');
		}
	}
}

if (!customElements.get('scrolling-collapsible')) {
	customElements.define('scrolling-collapsible', ScrollingCollapsible);
}

// //-------------- Rating Snippet ------------------

const targetNode = document.querySelector('.product-mobile-title.product-mobile-title--B .product-info__app');

if (targetNode) {
	const config = { childList: true, subtree: true };

	const callback = (mutationsList, observer) => {
		for (const mutation of mutationsList) {
			if (mutation.type === 'childList') {
				const targetElement = document.querySelector(
					'.product-mobile-title.product-mobile-title--B .product-info__app .ruk_rating_snippet',
				);
				if (targetElement) {
					observer.disconnect();
					const title = targetElement.getAttribute('title');
					const rating = title.split(' ')[0];

					const count = targetElement.querySelector('.ruk-rating-snippet-count');
					if (count) {
						const countDiv = document.createElement('span');
						countDiv.classList.add('rating-snippet-count--B');
						countDiv.innerText = ` ${rating} `;
						count.prepend(countDiv);
						console.log(count);
					}
				}
			}
		}
	};

	const observer = new MutationObserver(callback);
	observer.observe(targetNode, config);
}

const CART_EXPERIMENT_ID = 53678672;
window.activateCartExperiment = () => {
	let experimentsTable = window.ablyft.get('activeExperimentIds');
	const isExperimentActive = !!experimentsTable[CART_EXPERIMENT_ID];
	window['ablyft'] = window['ablyft'] || [];
	if (!isExperimentActive) {
		window['ablyft'].push({
			eventType: 'activatePage',
			pageApiName: 'restaxil-cart-drawer-first-time-accessed',
		});
	}
};
document.addEventListener('variant:add', () => {
	window.activateCartExperiment();
});
